import {createContext} from 'react';
import useFloatingTooltip from './useFloatingTooltip';

type ContextType = ReturnType<typeof useFloatingTooltip> | null;
const TooltipContext = createContext<ContextType>(null);

export default TooltipContext;
